/* eslint-disable id-length */
import { getImgixClient } from '@stockx/ui';
import { BASE_VARIABLE_QUALITIES } from '../consts';

interface Props {
  src: string;
  preferredImageFormat: string;
  dpr?: number;
  width?: number;
  height?: number;
  variableQualities?: {
    [key: number]: number;
  };
  extraImageParams?: object;
}

interface ReturnProps {
  imageSrc: string;
  imageSrcSet: string | undefined;
}

/**
 * Build for CATALOG image src sets.
 *
 * @param src
 * @param preferredImageFormat
 * @param dpr
 * @param width
 * @param height
 * @param variableQualities
 * @param extraImageParams
 */
const buildImageSrc = ({
  src,
  preferredImageFormat,
  width,
  height,
  variableQualities = BASE_VARIABLE_QUALITIES,
  extraImageParams = {},
}: Props): ReturnProps => {
  const { client, path } = getImgixClient(src);
  //
  // Catalog already include query params,
  // we need to merge the original query params with the ones we want to adjust.
  const parts: string[] = path.split('?');
  const searchParams = new URLSearchParams(parts[1] ?? '');
  const { q, ...query } = Object.fromEntries(searchParams.entries()); // eslint-disable-line @typescript-eslint/no-unused-vars

  const imageSrc: string = client?.buildURL(parts[0], {
    ...query,
    ...extraImageParams,
    w: width,
    h: height,
    fm: preferredImageFormat,
    q: 75,
    auto: 'compress',
  });

  const srcSetParams = {
    ...query,
    ...extraImageParams,
    w: width,
    h: height,
    auto: 'compress',
    fm: preferredImageFormat,
  };

  const imageSrcSet: string | undefined = client?.buildSrcSet(
    parts[0],
    srcSetParams,
    {
      variableQualities,
    },
  );

  return {
    imageSrc,
    imageSrcSet,
  };
};

export default buildImageSrc;
